import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=a1f1cc60&scoped=true"
import script from "./Clubs.vue?vue&type=script&lang=js"
export * from "./Clubs.vue?vue&type=script&lang=js"
import style0 from "./Clubs.vue?vue&type=style&index=0&id=a1f1cc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f1cc60",
  null
  
)

export default component.exports